import { useState } from 'react';
import { Popup, FlowForm } from 't-lib-ui/structure';
import { TextButton } from 't-lib-ui/widgets';
import MailIcon from './MailIcon';
import './NewsletterInfoPopup.css';

interface NewsletterInfoPopupProps {
  show: boolean;
  /** The inbox email address (without the mailto: prefix). */
  email: string;
  /** Feed title, shown in the explanation. */
  feedTitle?: string;
  onClose: () => void;
  closeFocus?: string;
}

const NewsletterInfoPopup: React.FC<NewsletterInfoPopupProps> = ({ show, email, feedTitle, onClose, closeFocus }) => {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(email);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Clipboard may be unavailable (e.g. insecure context) — the address is still shown.
    }
  };

  return (
    <Popup show={show} title="Newsletter inbox" onClose={onClose} closable minWidth="320px" closeFocus={closeFocus} className="newsletterInfoPopup">
      <FlowForm className="nlInfo">
        <div className="nlInfoIcon"><MailIcon size={26} color="currentColor" /></div>
        <p className="nlInfoLede">
          Emails sent to this address arrive as posts{feedTitle ? <> in <strong>{feedTitle}</strong></> : null}. The
          address is private to you.
        </p>
        <div className="nlInfoEmailBox" onClick={e => e.stopPropagation()}>
          <span className="nlInfoEmail" title={email}>{email}</span>
          <TextButton label={copied ? 'Copied!' : 'Copy'} type="major" size="small" focussable="flow" onClick={copy} />
        </div>
        <p className="nlInfoHint">
          Subscribe to a newsletter with it, or forward newsletters you already receive.
        </p>
      </FlowForm>
    </Popup>
  );
};

export default NewsletterInfoPopup;
